export const PROMOTED_PIXEL = 'pixel_id'
export const CUSTOM_EVENT_TYPE = 'custom_event_type'

export const promotedObjectInitialValues = {
  [PROMOTED_PIXEL]: '',
  [CUSTOM_EVENT_TYPE]: 'purchase'
}
